export default {
  storefront_not_found: {
    title: 'Keine storefront gefunden',
    description: 'Bitte erstellen Sie eine storefront.',
  },
};
